module.exports = __webpack_public_path__ + "img/zixun4.be7a488a.png";